import { get } from 'lodash';
import React from 'react';
import { Text, Wrapper } from './styled';
import DateFormatter from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/Date';

const ExecutionDates = ({ currentTool }) => {
  const start = get(currentTool, 'create_date', '');
  const end = get(currentTool, 'update_date', '');
  const startDate = new Date(start);
  const formattedStart = startDate.toISOString().slice(0, 19).replace('T', ' ');
  const endDate = new Date(end);
  const formattedEnd = endDate.toISOString().slice(0, 19).replace('T', ' ');

  return (
    <Wrapper>
        <Text>
            <strong>Start</strong>: <DateFormatter date={ formattedStart } />
        </Text>
        <Text>
            <strong>End</strong>: <DateFormatter date={ formattedEnd } />
        </Text>
    </Wrapper>
  );
};

export default ExecutionDates;
